// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"styles":"f53aa15aa7fe9959","md-light-indigo":"7c0e3efe66761e2d","md-dark-indigo":"20e10afaf6299154"}[chunkId] + ".css";
};